export enum StripeQueryParams {
  Success = 'stripe_confirm=success',
  Cancel = 'stripe_confirm=cancel',
}
